const fixLegacyGamePath = (path = '') => {
  if (path.startsWith('/casino/casino')) {
    return path.replace('/casino/casino', '/casino/play');
  }
  return path.replace('/casino', '/play');
};

export default fixLegacyGamePath;
